import { useQuery } from "@tanstack/react-query"
import { reveniIntegrationQuery } from "../../lib/reveni/reveniIntegrationQuery"

export function useReveniIntegrationQuery(...args: Parameters<typeof reveniIntegrationQuery>) {
  return useQuery(reveniIntegrationQuery(...args))
}
